import { toast } from 'react-toastify';
import { Api } from '../lib/api/api';

export const getProductGroupsByCompany = (token, cid) => async dispatch => {
  const api = new Api(token);

  dispatch({
    type: 'GET_PRODUCTS_BY_COMPANY',
  });

  try {
    const productGroups = await api.products.getProductGroupsByCompany(cid);
  } catch (error) {
    dispatch({
      type: 'GET_PRODUCTS_BY_COMPANY_ERROR',
    });
  }
};
export const productGroupList = productGroups => async dispatch => {
  dispatch({
    type: 'PRODUCT_GROUP_LIST',
    productGroups,
  });
};

export const oneTimeChargeGroupList = oneTimeCharge => async dispatch => {
  dispatch({
    type: 'OTC_GROUP_LIST',
    oneTimeCharge,
  });
};

export const oneTimeChargeTemplate = otc_template => async dispatch => {
  dispatch({
    type: 'OTC_TEMPLATE',
    otc_template,
  });
};

export const installationGroupList = installationGroups => async dispatch => {
  dispatch({
    type: 'INSTALLATION_GROUP_LIST',
    installationGroups,
  });
};

export const getOTCByCompany = (token, cid) => async dispatch => {
  const api = new Api(token);

  dispatch({
    type: 'GET_OTC_BY_COMPANY',
  });
};

export const getInstallationChargesByCompany = (token, cid) => async dispatch => {
  const api = new Api(token);

  dispatch({
    type: 'GET_INSTALLATION_CHARGES_BY_COMPANY_SUCCESS',
  });
};

export const updateProductGroupsById = (token, pgid, productGroups) => async dispatch => {
  const api = new Api(token);

  dispatch({
    type: 'UPDATE_PRODUCTS_GROUPS',
  });

  try {
    await api.products.updateProductGroupsById(pgid, productGroups);
    dispatch({
      type: 'UPDATE_PRODUCTS_GROUPS_SUCCESS',
    });
    toast.success('Product groups updated!', { toastId: 'UPDATE_PRODUCTS_GROUPS_SUCCESS' });
  } catch (error) {
    dispatch({
      type: 'UPDATE_PRODUCTS_GROUPS_ERROR',
    });
    toast.error(error.message || 'Error update product groups', {
      toastId: 'UPDATE_PRODUCTS_GROUPS_ERROR',
    });
    throw new Error(error);
  }
};

export const updateOTCProductGroupsById = (token, pgid, productGroups) => async dispatch => {
  const api = new Api(token);

  dispatch({
    type: 'UPDATE_OTC_PRODUCTS_GROUPS',
  });

  try {
    await api.products.updateOTCProductGroupsById(pgid, productGroups);
    dispatch({
      type: 'UPDATE_OTC_PRODUCTS_GROUPS_SUCCESS',
    });
    toast.success('Product groups updated!', { toastId: 'UPDATE_OTC_PRODUCTS_GROUPS_SUCCESS' });
  } catch (error) {
    dispatch({
      type: 'UPDATE_OTC_PRODUCTS_GROUPS_ERROR',
    });
    toast.error(error.message || 'Error update One Time Charge groups', {
      toastId: 'UPDATE_OTC_PRODUCTS_GROUPS_ERROR',
    });
    throw new Error(error);
  }
};

export const updateInstallationGroupsById = (token, pgid, productGroups) => async dispatch => {
  const api = new Api(token);

  dispatch({
    type: 'UPDATE_INS_PRODUCTS_GROUPS',
  });

  try {
    await api.products.updateInstallationGroupsById(pgid, productGroups);
    dispatch({
      type: 'UPDATE_INS_PRODUCTS_GROUPS_SUCCESS',
    });
    toast.success('Product groups updated!', { toastId: 'UPDATE_INS_PRODUCTS_GROUPS_SUCCESS' });
  } catch (error) {
    dispatch({
      type: 'UPDATE_INS_PRODUCTS_GROUPS_ERROR',
    });
    toast.error(error.message || 'Error update One Time Charge groups', {
      toastId: 'UPDATE_INS_PRODUCTS_GROUPS_ERROR',
    });
    throw new Error(error);
  }
};

export const insertProductGroupsIntoCompany = (token, cid, productGroups) => async dispatch => {
  const api = new Api(token);

  dispatch({
    type: 'ADD_PRODUCTS_INTO_COMPANY',
  });

  try {
    await api.products.insertProductGroupsIntoCompany(cid, productGroups);
    dispatch({
      type: 'ADD_PRODUCTS_INTO_COMPANY_SUCCESS',
    });
    toast.success('New product groups saved!', { toastId: 'ADD_PRODUCTS_INTO_COMPANY_SUCCESS' });
  } catch (error) {
    dispatch({
      type: 'ADD_PRODUCTS_INTO_COMPANY_ERROR',
    });
    toast.error(error.message || 'Error save product groups', {
      toastId: 'ADD_PRODUCTS_INTO_COMPANY_ERROR',
    });
    throw new Error(error);
  }
};

export const insertOTCGroup = (token, tid, productGroups) => async dispatch => {
  const api = new Api(token);

  dispatch({
    type: 'ADD_OTC_PRODUCTS_INTO_COMPANY',
  });

  try {
    await api.products.insertOTCGroup(tid, productGroups);
    dispatch({
      type: 'ADD_OTC_PRODUCTS_INTO_COMPANY_SUCCESS',
    });
    toast.success('New product groups saved!', {
      toastId: 'ADD_OTC_PRODUCTS_INTO_COMPANY_SUCCESS',
    });
  } catch (error) {
    dispatch({
      type: 'ADD_OTC_PRODUCTS_INTO_COMPANY_ERROR',
    });
    toast.error(error.message || 'Error save product groups', {
      toastId: 'ADD_OTC_PRODUCTS_INTO_COMPANY_ERROR',
    });
    throw new Error(error);
  }
};

export const insertInstallationGroupsIntoCompany = (
  token,
  cid,
  productGroups,
) => async dispatch => {
  const api = new Api(token);

  dispatch({
    type: 'ADD_INST_PRODUCTS_INTO_COMPANY',
  });

  try {
    await api.products.insertInstallationGroupsIntoCompany(cid, productGroups);
    dispatch({
      type: 'ADD_INST_PRODUCTS_INTO_COMPANY_SUCCESS',
    });
    toast.success('New product groups saved!', {
      toastId: 'ADD_INST_PRODUCTS_INTO_COMPANY_SUCCESS',
    });
  } catch (error) {
    dispatch({
      type: 'ADD_INST_PRODUCTS_INTO_COMPANY_ERROR',
    });
    toast.error(error.message || 'Error save product groups', {
      toastId: 'ADD_INST_PRODUCTS_INTO_COMPANY_ERROR',
    });
    throw new Error(error);
  }
};

export const deleteProductGroup = (token, id) => async dispatch => {
  const api = new Api(token);

  dispatch({
    type: 'DELETE_PRODUCT_GROUP',
  });

  try {
    await api.products.deleteProductGroup(id);
    dispatch({
      type: 'DELETE_PRODUCT_GROUP_SUCCESS',
    });
    toast.success('Product group deleted', { toastId: 'DELETE_PRODUCT_GROUP_SUCCESS' });
    return true;
  } catch (error) {
    dispatch({
      type: 'DELETE_PRODUCT_GROUP_ERROR',
    });
    toast.error(error.message || 'Error deleting product groups', {
      toastId: 'DELETE_PRODUCT_GROUP_ERROR',
    });
    return false;
  }
};

export const deleteOtcProductGroup = (token, cid, pid) => async dispatch => {
  const api = new Api(token);

  dispatch({
    type: 'DELETE_OTC_PRODUCT_GROUP',
  });

  try {
    await api.products.deleteOtcProductGroup(cid, pid);
    dispatch({
      type: 'DELETE_OTC_PRODUCT_GROUP_SUCCESS',
    });
    toast.success('Product group deleted', { toastId: 'DELETE_OTC_PRODUCT_GROUP_SUCCESS' });
    return true;
  } catch (error) {
    dispatch({
      type: 'DELETE_OTC_PRODUCT_GROUP_ERROR',
    });
    toast.error(error.message || 'Error deleting product groups', {
      toastId: 'DELETE_OTC_PRODUCT_GROUP_ERROR',
    });
    return false;
  }
};

export const deleteInstProductGroup = (token, cid, pid) => async dispatch => {
  const api = new Api(token);

  dispatch({
    type: 'DELETE_OTC_PRODUCT_GROUP',
  });

  try {
    await api.products.deleteInstProductGroup(cid, pid);
    dispatch({
      type: 'DELETE_INST_PRODUCT_GROUP_SUCCESS',
    });
    toast.success('Product group deleted', { toastId: 'DELETE_INST_PRODUCT_GROUP_SUCCESS' });
    return true;
  } catch (error) {
    dispatch({
      type: 'DELETE_INST_PRODUCT_GROUP_ERROR',
    });
    toast.error(error.message || 'Error deleting product groups', {
      toastId: 'DELETE_INST_PRODUCT_GROUP_ERROR',
    });
    return false;
  }
};

export const setEditMode = mode => dispatch => {
  dispatch({
    type: 'SET_EDIT_MODE_PRODUCTS',
    mode,
  });
};

export const setProductGroupsData = productGroupsData => dispatch => {
  dispatch({
    type: 'SET_PRODUCT_GROUPS_DATA',
    productGroupsData,
  });
};

export const activeTab = tab => dispatch => {
  dispatch({
    type: 'SET_ACTIVE_TAB',
    tab,
  });
};

export const resetProductGroupsData = tab => dispatch => {
  dispatch({
    type: 'RESET_PRODUCT_GROUPS_DATA',
    tab,
  });
};

export const onFieldProductGroupsUpdate = (name, value) => dispatch => {
  dispatch({
    type: 'UPDATE_FIELD_PRODUCT_GROUPS_DATA',
    name,
    value,
  });
};

export const onFieldProductUpdate = (productIndex, name, value) => dispatch => {
  dispatch({
    type: 'UPDATE_FIELD_PRODUCT_DATA',
    productIndex,
    name,
    value,
  });
};

export const onFieldProductPriceUpdate = (productIndex, key, price) => dispatch => {
  dispatch({
    type: 'UPDATE_PRICE_PRODUCT',
    productIndex,
    key,
    price,
  });
};

export const onOTCProductPriceUpdate = (productIndex, key, price) => dispatch => {
  dispatch({
    type: 'UPDATE_OTC_PRICE_PRODUCT',
    productIndex,
    key,
    price,
  });
};

export const addProduct = () => dispatch => {
  dispatch({
    type: 'ADD_PRODUCT',
  });
};

export const addOTCProduct = () => dispatch => {
  dispatch({
    type: 'ADD_OTC_PRODUCT',
  });
};

export const deleteProduct = productIndex => dispatch => {
  dispatch({
    type: 'DELETE_PRODUCT',
    productIndex,
  });
  dispatch({
    type: 'CONFIRM_DELETE_PRODUCT',
  });
};

export const showDeleteModal = productIndex => dispatch => {
  dispatch({
    type: 'SHOW_DELETE_PRODUCT_MODAL',
    productIndex,
  });
};

export const cancelDeleteProduct = () => dispatch => {
  dispatch({
    type: 'CANCEL_DELETE_PRODUCT',
  });
};

export const setCreateMode = mode => dispatch => {
  dispatch({
    type: 'SET_CREATE_MODE',
    mode,
  });
};

export const getTemplates = (token, type) => async dispatch => {
  const api = new Api(token);
  try {
    const templates = await api.products.getOneTimeTemplates(type);
    if (type === 'productGroup') {
      dispatch({
        type: 'GET_PRODUCT_GROUP_TEMPLATE_SUCCESS',
        templates,
      });
      dispatch(productGroupList(templates[templates.length - 1].productGroupCharges));
    }
    // if (type === 'oneTimeCharge') {
    //   dispatch({
    //     type: 'GET_ONE_TIME_CHARGE_TEMPLATES_SUCCESS',
    //     templates,
    //   });
    //   dispatch(oneTimeChargeGroupList(templates[templates.length - 1].oneTimeCharges));
    // }
    // if (type === 'installation') {
    //   dispatch({
    //     type: 'GET_INSTALLATION_TEMPLATE_SUCCESS',
    //     templates,
    //   });
    //   dispatch(installationGroupList(templates[templates.length - 1].oneTimeCharges));
    // }
    return templates;
  } catch (error) {
    dispatch({
      type: 'GET_ONE_TIME_TEMPLATES_ERROR',
    });
  }
};

export const addTemplates = (token, type, template) => async dispatch => {
  const api = new Api(token);
  try {
    const res = await api.products.addOneTimeTemplates(type, template);
    if (type === 'productGroup') {
      toast.success('Template added successfully!');
    }
    return res;
  } catch (error) {
    toast.error(error.response.data || 'Something went wrong');
    return false;
  }
};

export const getOneTimeTemplatesByID = (token, type, id) => async dispatch => {
  const api = new Api(token);
  try {
    const template = await api.products.getOTTById(type, id);
    if (type === 'productGroup') {
      dispatch(productGroupList(template.productGroupCharges));
    }
    if (type === 'oneTimeCharge') {
      dispatch(oneTimeChargeGroupList(template.oneTimeCharges));
      dispatch(oneTimeChargeTemplate(template));

    }
    return template;
  } catch (error) {
    dispatch({
      type: 'GET_ONE_TIME_TEMPLATES_ERROR',
    });
  }
};

export const insertProductGroupsByID = (token, tId, productGroups) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'ADD_PRODUCTS_INTO_COMPANY',
  });
  try {
    await api.products.insertProductGroupById(tId, productGroups);
    toast.success('New product groups saved!', { toastId: 'ADD_PRODUCTS_BY_ID_SUCCESS' });
  } catch (error) {
    toast.error(error.message || 'Error save product groups', {
      toastId: 'ADD_PRODUCTS_BY_ID_ERROR',
    });
    throw new Error(error);
  }
};

export const deleteProductGroupByTemplateId = (token, pgId, tId) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'DELETE_PRODUCT_GROUP',
  });
  try {
    await api.products.deleteProductGroupByTemplateId(pgId, tId);
    dispatch({
      type: 'DELETE_PRODUCT_GROUP_SUCCESS',
    });
    toast.success('Product group deleted', { toastId: 'DELETE_PRODUCT_GROUP_SUCCESS' });
    return true;
  } catch (error) {
    dispatch({
      type: 'DELETE_PRODUCT_GROUP_ERROR',
    });
    toast.error(error.message || 'Error deleting product groups', {
      toastId: 'DELETE_PRODUCT_GROUP_ERROR',
    });
    return false;
  }
};

export const deleteOtcProductGroupByTemplateId = (token, pgId, tId) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'DELETE_OTC_PRODUCT_GROUP',
  });
  try {
    await api.products.deleteOtcProductGroupByTemplateId(pgId, tId);
    dispatch({
      type: 'DELETE_OTC_PRODUCT_GROUP_SUCCESS',
    });
    toast.success('Product group deleted', { toastId: 'DELETE_PRODUCT_GROUP_SUCCESS' });
    return true;
  } catch (error) {
    dispatch({
      type: 'DELETE_OTC_PRODUCT_GROUP_ERROR',
    });
    toast.error(error.message || 'Error deleting product groups', {
      toastId: 'DELETE_OTC_PRODUCT_GROUP_ERROR',
    });
    return false;
  }
};
